import { useMutation } from "@tanstack/react-query";
import {
  getMotionAmplificationJobDownloadUrls,
  type MotionAmplificationJobId,
} from "../clients/motion-amplification";

type VideoFile = "original" | "processed";
type VideoRequest = VideoFile | "raw";

export function useMotionAmplificationJobDownload() {
  const downloadUrlsMutation = useMutation({
    mutationFn: async ({
      jobId,
      file,
    }: {
      jobId: MotionAmplificationJobId;
      file: VideoRequest;
    }) => {
      const downloadUrls = await getMotionAmplificationJobDownloadUrls(jobId);
      const url =
        file === "raw"
          ? downloadUrls.rawVideoUrl
          : file === "original"
            ? downloadUrls.rawVideoDownloadUrl
            : downloadUrls.processedVideoDownloadUrl;

      if (!url) throw new Error("The requested video is not available.");

      return url;
    },
  });

  async function download(jobId: MotionAmplificationJobId, file: VideoFile) {
    globalThis.location.assign(
      await downloadUrlsMutation.mutateAsync({ jobId, file }),
    );
  }

  async function getRawVideoUrl(jobId: MotionAmplificationJobId) {
    return downloadUrlsMutation.mutateAsync({ jobId, file: "raw" });
  }

  return {
    download,
    getRawVideoUrl,
    error: downloadUrlsMutation.error,
    isDownloading: downloadUrlsMutation.isPending,
  };
}
